import { Environment, environment } from '@repo/environment';

import { Config } from './config.interface';
import { developConfig } from './develop.config';
import { localConfig } from './local.config';
import { productionConfig } from './production.config';
import { stagingConfig } from './staging.config';

let config: Config;

switch (environment) {
  case Environment.PRODUCTION:
    config = productionConfig;
    break;
  case Environment.DEVELOPMENT:
    config = developConfig;
    break;
  case Environment.LOCAL:
  case Environment.TEST:
    config = localConfig;
    break;
  default:
    config = stagingConfig;
}

export { config };
